import React, { useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import Input from "../components/Input";
import API from "../api/api";

export default function AdminDashboard() {
    const [nombre, setNombre] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("cliente");

    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nombre || !email || !password) {
            setError("Complete todos los campos");
            return;
        }

        console.log("DATA ENVIADA:", {
            email,
            password,
            role,
            nombre,
        });

        setError("");
        setSuccess("");
        setLoading(true);

        try {
            await API.post("/auth/register/", {
                nombre,
                email,
                password,
                role,
            });

            setSuccess(`Usuario ${nombre} creado exitosamente`);

            setEmail("");
            setPassword("");
            setNombre("");
            setRole("cliente");
        } catch (err) {
            console.error(err);
            if (err.response?.data?.email) {
                setError("El email ya está registrado");
            } else if (err.response?.data?.detail) {
                setError(err.response.data.detail);
            } else {
                setError("Error al crear usuario. Verifique los datos.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto">
            <h1 className="text-3xl font-bold mb-6">Panel de Administración</h1>

            <Card>
                <h2 className="text-xl font-semibold mb-4">Crear Nuevo Usuario</h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <Input
                        label="Nombre completo"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        required
                    />

                    <Input
                        label="Email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <Input
                        label="Contraseña"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <div className="flex flex-col gap-1">
                        <label className="text-sm font-medium">Tipo de cuenta</label>
                        <select
                            className="border border-slate-300 rounded p-2"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="cliente">Cliente (vende cheques)</option>
                            <option value="comprador">Comprador (financiera)</option>
                        </select>
                    </div>

                    {error && (
                        <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
                            {error}
                        </div>
                    )}

                    {success && (
                        <div className="p-3 bg-green-50 border border-green-200 rounded text-green-700 text-sm">
                            {success}
                        </div>
                    )}

                    <Button type="submit" className="w-full" disabled={loading}>
                        {loading ? "Creando..." : "Crear Usuario"}
                    </Button>
                </form>
            </Card>
        </div>
    );
}
